<template>
  <ModalForm
    :title="`Копировать позицию ${copyPositions[activePositionIndex].name }?`"
    class="modal--title-reset"

    text-btn-confirm="Подтвердить"
    text-btn-reject="Отмена"

    @request="submitCopyPosition"
    @reject="close"
  >
  </ModalForm>
</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm.vue'

import { mapActions, mapGetters } from 'vuex'
import { showAlertError, showAlertSuccess } from '@/utils/store/alert'
import { mixinTimeout } from '@/mixins/mixinTimeout'

export default {
  name: 'ModalPositionCopy',
  components: {
    ModalForm
  },
  mixins: [mixinTimeout],

  props: {
    activePositionIndex: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapGetters('orderDetail', {
      copyPositions: 'copyPositions'
    })
  },

  methods: {
    ...mapActions('orderDetail', {
      copyPosition: 'copyPosition'
    }),

    async submitCopyPosition () {
      try {
        this.$store.commit('START_IS_SENDING_REQUEST_MODAL')

        const postData = {
          value: null,
          position_id: this.copyPositions[this.activePositionIndex].id
        }

        await this.copyPosition(postData)

        showAlertSuccess('Позиция скопирована')
        this.close()
      } catch (e) {
        showAlertError(e)
      } finally {
        this.$store.commit('FINISH_IS_SENDING_REQUEST_MODAL')
      }
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
